import { jsx as _jsx } from "react/jsx-runtime";
import { storeSet, useWindow } from '@cmd/ui-utilities';
import { useSelector } from 'react-redux';
import logiEnabledOrgs from '../logi/logiEnabledOrgs';
import LogiView from '../logi/LogiView';
import { organizationSelector } from '../state/orgIdState';
import TileSection from '../tiles/tile-section/TileSection';
import TotalLeads from '../tiles/tiles/total-leads/TotalLeads';
import UnitsSold from '../tiles/tiles/units-sold/UnitsSold';
import { LeadsDataSource } from '../utils/apis/leadsApiUtils';
import WebComponentView from '../web-components/WebComponentView';
const { reducer: webComponentViewReducer, selector: webComponentViewSelector, urlUpdater: webComponentViewUrlUpdater, } = storeSet('webComponentView', false, null, (v) => (v === 'true'), (v) => v.toString());
const LandingPageContent = () => {
    const orgId = useSelector(organizationSelector);
    const webComponentView = useSelector(webComponentViewSelector);
    const { cmdContainer: { environment, }, } = useWindow();
    const logiViewEnabled = !!orgId && logiEnabledOrgs.includes(orgId);
    // ToDo remove "environment === 'dev'" once token flow is set up
    if (logiViewEnabled && environment !== 'prod') {
        return _jsx(LogiView, {});
    }
    if (webComponentView && environment === 'dev') {
        return _jsx(WebComponentView, {});
    }
    return (_jsx(TileSection, { header: "Sales", tiles: [
            _jsx(TotalLeads, { source: LeadsDataSource.VIN_SOLUTIONS, "data-testid": "ids-vin" }),
            _jsx(TotalLeads, { source: LeadsDataSource.DDC, "data-testid": "ids-ddc" }),
            _jsx(TotalLeads, { source: LeadsDataSource.ATKBB, "data-testid": "ids-atkbb" }),
            _jsx(TotalLeads, { source: LeadsDataSource.ICO, "data-testid": "ids-ico" }),
            _jsx(UnitsSold, {}),
        ] }));
};
export { webComponentViewReducer, webComponentViewUrlUpdater, };
export default LandingPageContent;
